import { defineStore } from 'pinia'
import FtpSettingsState, { FtpSettingsStateType } from './state'
import { FtpSettingsActions, FtpSettingsActionsType } from './actions'
import { FtpSettingsGetters } from './getters'

export const useFtpSettingsStore = defineStore<
  'ftpSettings',
  FtpSettingsStateType,
  typeof FtpSettingsGetters,
  FtpSettingsActionsType
>('ftpSettings', {
  state: FtpSettingsState,
  actions: FtpSettingsActions,
  getters: FtpSettingsGetters,
})
